import React from 'react'

/**
 * TABLEFONTBOOST-2026-10-01 — A-/A+ control for SO V3 / Invoice V3's whole
 * UI zoom (client's ask, on top of the base +2pt fix in
 * css/table-font-boost.css — "no estaría mal tener algunos botones que
 * puedan aumentar el tamaño de la fuente a nivel global").
 *
 * 2026-10-01 follow-up (client feedback on the first version):
 *   1. "el text size solo cambia la tabla... era en general la UI" — fixed
 *      by having the parent page apply `scale` as a CSS `zoom` on its own
 *      outer wrapper (not a CSS variable scoped to .textTableSize), so this
 *      affects every descendant — the catalog modal included — not just
 *      table rows carrying that one class.
 *   2. "tenerlo tan abajo... no estoy seguro que los vean los usuarios" —
 *      now rendered `position: fixed` (floating), not inline in the page
 *      flow, so it's visible regardless of scroll position. Caller passes
 *      `style` to position it (e.g. next to the offline-sync FAB).
 *   3. "los botones son fondo blanco y texto blanco" — Bootstrap's
 *      `.btn-outline-secondary` was coming out illegible in this app's CSS
 *      (some ambient rule stomps its color) — replaced with fully explicit
 *      inline colors, nothing left to a shared class that could clobber it.
 *
 * Fully controlled — no internal state, no localStorage here. The parent
 * page owns `scale`, persists it, and applies it as `zoom`.
 *
 * TOOLBAR-2026-10-02 — `embedded` (client's ask, SO V3 only so far): when
 * true, drops this component's own standalone pill chrome (background/
 * border-radius/shadow/padding) so it can sit as a plain segment inside a
 * parent toolbar (see so-v3-toolbar in css/table-font-boost.css) without a
 * "pill inside a pill" look. InvoiceV3.js doesn't pass this yet — it still
 * renders as its own standalone floating pill.
 */
export default function TableFontSizeControl({ scale, onChange, min = 0.85, max = 1.4, step = 0.1, style, embedded = false }) {
    const dec = () => onChange(Math.max(min, Number((scale - step).toFixed(2))))
    const inc = () => onChange(Math.min(max, Number((scale + step).toFixed(2))))

    const buttonStyle = (disabled) => ({
        width: '30px', height: '30px', borderRadius: '8px',
        border: '1px solid #cbd5e1',
        background: disabled ? '#f1f5f9' : '#ffffff',
        color: disabled ? '#94a3b8' : '#1e293b',
        fontWeight: 700, fontSize: '0.9rem', lineHeight: 1,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: disabled ? 'default' : 'pointer',
    })

    const wrapperStyle = embedded
        ? { display: 'inline-flex', alignItems: 'center', gap: '6px', ...style }
        : {
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            background: '#111827', borderRadius: '999px', padding: '6px 10px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, .2)', ...style,
        }

    return (
        <div style={wrapperStyle}>
            <span className="tfs-label" style={{ fontSize: '0.72rem', color: '#e5e7eb', fontWeight: 600 }}>Text size</span>
            <button type="button" style={buttonStyle(scale <= min)} disabled={scale <= min}
                onClick={dec} aria-label="Decrease text size">A-</button>
            <button type="button" style={buttonStyle(scale >= max)} disabled={scale >= max}
                onClick={inc} aria-label="Increase text size">A+</button>
        </div>
    )
}
